import {graphql} from '@apollo/client/react/hoc';
import {Card, CardHeader} from '@core/ui/Content';
import Loading from '@core/ui/Loading';
import {FeedAdsTable} from '@analytics/components/ads/AdsTable';
import {FeedNav} from '@analytics/components/nav/ResearchNav';
import FeedAdsQuery from '@analytics/graphql-api/_old_queries/research/FeedAdsQuery';

const FeedsAds = ({organization, feed, data: {loading, error, me}}) => {
  if (loading) {
    return <Loading fixed />;
  }

  const {ads} = me.organization.research.feed;

  return (
    <>
      <FeedNav organization={organization} feed={feed} />
      <CardHeader>Ads</CardHeader>
      <Card>
        <FeedAdsTable
          organization={organization}
          ads={ads}
          feed={feed}
          orderBy='-firstPublished'
        />
      </Card>
    </>
  );
};

export default graphql(FeedAdsQuery, {
  options: ({organization, feed: {id}}) => ({
    variables: {
      organizationId: organization.id,
      id,
      limit: 100,
      orderBy: '-first_published',
    },
  }),
})(FeedsAds);
